import queries from '@apis/queries';
import useItemCategories from '@hooks/category/useItemCategories';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { useContext } from 'react';

import { itemFilterAtom } from '../../../atoms/itemFilterAtoms';
import ShopItemContext from '../../../context/ShopItemContext';

function useItems() {
    const { shopId, categoryId: currentCategoryId } = useContext(ShopItemContext);
    const { categories } = useItemCategories(shopId);
    const categoryId = currentCategoryId || categories?.[0]?.id;
    const { data, status } = useQuery({
        ...queries.items.list(shopId, categoryId!),
        enabled: !!categoryId,
    });
    const filters = useAtomValue(itemFilterAtom);

    const withoutSoldOut = filters.includes('품절상품 제외');
    const badgeFilters = filters.filter((f) => f !== '품절상품 제외');
    const items = data?.items
        .filter((item) => (withoutSoldOut ? !item.isSoldOut : true))
        .filter((item) => {
            if (badgeFilters.length !== 0) {
                return badgeFilters.some((badge) => item.badges?.includes(badge));
            }
            return true;
        });
    const isBlank = ((!items || items.length === 0) && status !== 'pending')
      || !categoryId;
    const isLoading = status === 'pending' && !!categoryId;
    return {
        items, status, isBlank, isLoading,
    };
}

export default useItems;
